import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '@/mocks/faqs';
import AnimateSection from '@/components/base/AnimateSection';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <AnimateSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {t('home.faqTitle')}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              {t('home.faqDesc')}
            </p>
          </div>
        </AnimateSection>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <AnimateSection key={index} delay={index * 80} animation="animate-fade-in">
              <div className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                    <i
                      className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-400 ${
                    openIndex === index ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </AnimateSection>
          ))}
        </div>
      </div>
    </section>
  );
}